import request from "superagent";
import _ from "lodash";
import { getAuthHeader } from "../utils/superagent";

export const RETRIEVE = "locations/RETRIEVE";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {
  locations: [],
  groups: [],
  locationMap: {},
};

const getGroups = (locations) => {
  const mapGroups = (location) => (_.isEmpty(location.groups) ? location.name : location.groups);

  const groups = _.chain(locations).flatMap(mapGroups).uniq().value();

  return groups;
};

/**
 * Redux state management and other boilerplate code is painful to manage and hinders discoverability.
 * Redux code guidelines show this bizarre pattern with initializing function arguments
 * without a default for the action. Example:
 * https://redux.js.org/usage/structuring-reducers/initializing-state#single-simple-reducer
 * This is linted against via typical lint rules.
 * Unfortunately, redux recommends this, so we need to mark the lint rule as disabled until
 * we eliminate redux from the code base.
 * https://linear.app/clipboardhealth/issue/FEF-167/deprecate-redux
 */
// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE:
      return {
        ...state,
        locations: action.data,
        groups: getGroups(action.data),
        locationMap: _.keyBy(action.data, "_id"),
      };

    default:
      return state;
  }
};

export const getLocations = (data) => {
  return async (dispatch) => {
    return request
      .get(`${global.api}/location`)
      .set(await getAuthHeader())
      .send(data)
      .then((res) => {
        dispatch({
          type: RETRIEVE,
          data: res.body,
        });
      });
  };
};

export const getLocationFromRegions = (locationList, inputRegions) => {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const locations: any[] = [];
  const regions = inputRegions || [];

  _.forEach(locationList, (location) => {
    const groups = location.groups || [];

    if (_.isEmpty(groups) && regions.includes(location.name)) {
      locations.push(location._id);
      return;
    }

    if (groups.find((group) => regions.includes(group))) {
      locations.push(location._id);
    }
  });

  return locations;
};
